// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatBackgroundPopup__popup-a7af37 {
  max-height: 500px;
}

.ChatBackgroundPopup__container-ff3d6b {
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 80px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ChatBackgroundPopup/ChatBackgroundPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,oBAAA;AACF","sourcesContent":[".popup {\n  max-height: 500px;\n}\n\n.container {\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-bottom: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `ChatBackgroundPopup__popup-a7af37`,
	"container": `ChatBackgroundPopup__container-ff3d6b`
};
module.exports = ___CSS_LOADER_EXPORT___;
